import { createTemporaryId } from "../utils/model";
import { BasicFieldReference } from "./BasicField";
import { ProductReference } from "./ProductReference";

export class OrderPart {
  readonly id: string = createTemporaryId();
  readonly fields: BasicFieldReference[] = [];
  readonly products: ProductReference[] = [];
  readonly name: string = "";

  constructor(deriveFrom?: Partial<OrderPart>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }
}